import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "assets/scss/dashboard.scss";
import "assets/css/charts_form_controls.css";
import "assets/css/grid_table.css";
import numeral from "numeral";
import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import moment from "moment";
import { getDataApi, saveApi, loadApi } from "services/appApi";
import { pecaPageRows, pecaRowsPerPageOptions } from "pages/common/envPECA";
import axios from "axios";

const ProcessNamesPG = () => {
  let emptyRow = {
    admin_form_heading: "",
    created_by: null,
    creation_date: "",
    last_update_date: "",
    last_updated_by: null,
    process_description: null,
    process_end_date_active: null,
    process_id: null,
    process_name: "",
    process_start_date_active: null,
    process_start_lot_seq_number: null
  };

  /**** 31-May-2024 Velmani P. Following changes are made to template
   * 	a. Use a generic name "row" instead of "product".  Following are the name changed from template
   * 	   a1. products ==> rows
   * 		[products, setProducts] ==> [products, setRows]
   * 		[deleteProductsDialog, setDeleteProductsDialog] ==> [deleteRowsDialog, setDeleteRowsDialog]
   * 		[selectedProducts, setSelectedProducts] ==> [selectedRows, setSelectedRows]
   * 	   a2. product  ==> row
   *		[productDialog, setProductDialog] ==> [productDialog, setRowDialog]
   *		[deleteProductDialog, setDeleteProductDialog] ==> [deleteRowDialog, setDeleteRowDialog]
   *		[product, setProduct] ==> [product, setRow]
   * ******/
  const [rows, setRows] = useState([]);
  const [rowDialog, setRowDialog] = useState(false);
  const [deleteRowDialog, setDeleteRowDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [dialog, setDialog] = useState("");
  const [wasDataFetchingSuccessful, setWasDataFetchingSuccessful] = useState(true);
  const [processName, setProcessName] = useState("");
  const [description, setDescription] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const toast = useRef(null);
  const dt = useRef(null);

  // Fetch Processes when the component mounts
  const handleLoadData = async () => {

    const p_param = {
      p_process_name: processName,
      p_process_description: description,
      p_process_start_date_active: startDate,
      p_process_end_date_active: endDate,
    };
    console.log(p_param);
      try {
        setIsLoading(true);
        const response = await loadApi(p_param,"/api/setup/machineMG/process/selRows");
        console.log(response);
        console.log("Fetched processes:", response.data);
        console.log(response.data[0]);
        console.log(response.data[1]);
        if (response.data.length > 0) {
          let successFlag = response.data[0];
          if (successFlag === "Y") {
            toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            console.log("success=Y");
            setRows(response.data[1]);
            setIsLoading(false);
            setWasDataFetchingSuccessful(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
            const errorInfo = response.data[2];

            // Set the error message and display the dialog
            setErrorMessage(errorInfo);
            setErrorDialogVisible(true);
            setWasDataFetchingSuccessful(true);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          setWasDataFetchingSuccessful(true);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        console.log("Request was cancelled by the user.");

        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
        console.error("Error fetching processes:", error);
      }
      } finally {
      setIsLoading(false);
    }
    };

  const showProduct = (row) => {
    setRow({ ...row });
    setShowProductDialog(true);
  };
  const openNew = () => {
    setRow(emptyRow);
    setSubmitted(false);
    setRowDialog(true);
    setDialog("create")
  };

  const hideDialog = () => {
    setSubmitted(false);
    setRowDialog(false);
    setDialog("")
    setShowProductDialog(false);
    setErrorDialogVisible(false);
  };
  const hideDeleteRowDialog = () => {
    setDeleteRowDialog(false);
  };

  const formatDateColumn = (dateValue) => {
    return dateValue ? moment.utc(dateValue).format("YYYY-MM-DD") : null;
  };

  const startDateBodyTemplate = (rowData) => {
    return formatDateColumn(rowData.process_start_date_active);
  };

  const endDateBodyTemplate = (rowData) => {
    return formatDateColumn(rowData.process_end_date_active);
  };

  /***
        const formatDateFields = (row, isNew) => {
            const formatDate = (date) => date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : null;
    
            return {
                ...row,
                creation_date: isNew ? formatDate(new Date()) : formatDate(row.creation_date),
                last_update_date: formatDate(new Date()),
                start_date: formatDate(row.start_date),
                end_date: formatDate(row.end_date)
            };
        };
         */

  const saveRow = async () => {
    setSubmitted(true);

    if (row.process_name.trim()) {
      //      const isNew = !row.process_id;
      //     const formattedRow = formatDateFields(row, isNew);

      let _rows = [...rows];
      let _row = { ...row };

      try {
        if (row.process_id) {
          /*** Update Row */
          const response = await saveApi(row, "/api/setup/machineMG/process/updRow");
          //await axios.put(`http://localhost:5000/api/machines/${row.machine_id}`, formattedRow);
          //             const updatedRows = rows.map((p) => (p.machine_id === row.machine_id ? formattedRow : p));
          //             setRows(updatedRows);
          console.log("updating");
          console.log(response.data);
          let successFlag = response.data[0];
          if (successFlag === "Y") {
            const index = findIndexById(row.process_id);
            _rows[index] = _row;
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Process Updated",
              life: 3000,
              width: "600px",
            });
          } else {
            let err_msg = response.data[1];
            toast.current.show({
              severity: "error",
              summary: err_msg,
              detail: "Process Not Updated",
              life: 3000,
              width: "600px",
            });
          }
        } else {
          /*** Insert Row */
          const response = await saveApi(row, "/api/setup/machineMG/process/insRow");
          //const response = await axios.post('http://localhost:5000/api/machines', formattedRow);
          //       formattedRow.machine_id = response.data.id;
          //     setRows([...rows, formattedRow]);
          console.log("saving");
          console.log("Response data: ", response.data);
          console.log("Response: ", response);
          let successFlag =
            response.data[0]; /** This contains value of Y or N */
          if (successFlag === "Y") {
            _row.process_id =
              response.data[1]; /** It contains newly created Id */
            _rows.push(_row);
            toast.current.show({
              severity: "success",
              summary: (
                <div style={{ marginright: "200px", width: "600px" }}>
                  Success
                </div>
              ),
              detail: <div style={{ width: "600px" }}>Process Created</div>,
              life: 3000,
              width: "600px",
            });
          } else {
            let err_msg = response.data[2];
            toast.current.show({
              severity: "error",
              summary: <div style={{ width: "600px" }}>{err_msg}</div>,
              detail: <div style={{ width: "600px" }}>{err_msg}</div>,
              life: 3000,
              width: "600px",
            });
          }
        }

        setRows(_rows);
        setRowDialog(false);
        setRow(emptyRow);
      } catch (error) {
        console.error("Error saving process:", error);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Process Save Failed",
          life: 3000,
          width: "600px",
        });
      }
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Please fill in all required fields",
        life: 3000,
        width: "600px",
      });
    }
  };

  const editRow = (row) => {
    setRow({ ...row });
    setRowDialog(true);
    setDialog("edit")
  };

  const confirmDeleteRow = (row) => {
    setRow(row);
    setDeleteRowDialog(true);
  };

  const deleteRow = async () => {
    try {
      const response = await saveApi(row, "/api/setup/machineMG/process/delRow");
      let successFlag = response.data[0];
      if (successFlag === "Y") {
        let _rows = rows.filter((val) => val.process_id !== row.process_id);
        setRows(_rows);
        setDeleteRowDialog(false);
        setRow(emptyRow);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Process Deleted",
          life: 3000,
          width: "600px",
        });
      } else {
        let err_msg = response.data[1];
        toast.current.show({
          severity: "error",
          summary: err_msg,
          detail: "Process Not Deleted",
          life: 3000,
          width: "600px",
        });
      }
    } catch (error) {
      console.error("Error deleting process:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Process Deletion Failed",
        life: 3000,
        width: "600px",
      });
    }
  };

  const findIndexById = (id) => {
    let index = -1;
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].process_id === id) {
        index = i;
        break;
      }
    }
    return index;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const getLoadingHeaderContents = () => {
    return (
      <React.Fragment>
        <div className="row d-flex justify-content-center m-5">
          <div className="col-auto">
            <div className="card shadow-sm border-primary">
              <div className="card-header bg-primary text-white">
                <h2 className="mb-0">Inquire Process Name</h2>
              </div>
              <div className="card-body text-center">
                <h3>
                  <i className="fa-duotone fa-fw fa-spin-pulse fa-loader me-3"></i>{" "}
                  The page is loading...
                </h3>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  const getLoadedHeaderContents = () => {
                  return (
                    <React.Fragment>
                      <div className="header-container">
                        <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                        Inquire Process Name
                        </h2>
                        <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                          <div className="header-container p-1">
                              <style>
                              {`
                                input::placeholder {
                                  font-size: 17px; 
                                }
                              `}
                            </style>
                          {/* <span className="p-input-icon-right w-full md:w-auto"> 
                        <InputText
                          type="search"
                          onInput={(e) => setGlobalFilter(e.target.value)}
                          placeholder="Search..."
                          className="w-full lg:w-auto text-sm p-3"
                          style={{ fontSize: '17px' }} 
                        />
                      </span> */}
                          </div>
                        </h2>
                      </div>
                    </React.Fragment>
                  );
                }

  const deleteRowDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        className="p-button-primary p-mr-2"
        onClick={hideDeleteRowDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        className="p-button-danger"
        style={{ marginLeft: "10px" }}
        onClick={deleteRow}
      />
    </React.Fragment>
  );

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _row = { ...row };
    _row[`${name}`] = val;

    setRow(_row);
  };

  /***
    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="New" icon="pi pi-plus" className="p-button-success p-mr-2" onClick={openNew} />
            </React.Fragment>
        )
    }

    const headerDontUse = (
        <div className="table-header">
            <h5 className="p-m-0">Manage Machines</h5>
            {/* <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
            </span> * /}
        </div>
    );
    */

  const header = (
    <div
      className="table-header"
      style={{
        display: "flex",
        justifyContent: "space-between",
        height: "3rem",
        alignContent: "center",
      }}
    >
      <div
        style={{
          width: window.innerWidth / 3,
          display: "flex",
          justifyContent: "flex-start",
          marginRight: "110px",
        }}
      >
        <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span>
      </div>
      <div>
        <Button
          // label="New"
          icon="pi pi-plus"
          className="p-button-rounded p-button-success p-mr-2"
          onClick={openNew}
          tooltip="New"
          tooltipOptions={{ position: "bottom" }}
        />
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
          style={{ marginLeft: "20px" }}
        />
      </div>
    </div>
  );

  const actionBodyEditTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-success p-mr-2"
          onClick={() => editRow(rowData)}
          tooltip="Edit"
          tooltipOptions={{ position: "bottom" }}
          // disabled={true}
        />
      </React.Fragment>
    );
  };

  const actionBodyDeleteTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-warning"
          onClick={() => confirmDeleteRow(rowData)}
          tooltip="Delete"
          tooltipOptions={{ position: "bottom" }}
          // disabled={true}
        />
      </React.Fragment>
    );
  };

  const lotTemplate = (rowData) => {
    return numeral(rowData.process_start_lot_seq_number).format("0,0");
  };

  const lotNumber = row.process_start_lot_seq_number ? numeral(row.process_start_lot_seq_number).format("0,0") : null;
  const sDate = row.process_start_date_active ? moment.utc(row.process_start_date_active).format("YYYY-MM-DD") : null;
  const eDate = row.process_end_date_active ? moment.utc(row.process_end_date_active).format("YYYY-MM-DD") : null;

  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

     const CardComponent = ({title, data}) => {
          const rightAlignedLabels = ["Process Start Lot Seq Number : "]
    
          return (
            <Card className="card-containers">
              <h5  style={{"fontWeight":"bold"}}> {title} </h5>
              <Divider className="my-2" />
              {data.map((item, index) => (
                <div key={index} className="label-value-pair">
                  <span className="label">{item.label}</span>
                  
                  {item.label &&
                  <span         
                  className={`value-box ${rightAlignedLabels.includes(item.label) ? "align-right": ""}`}>
                    {item.value}</span>
                  }
                  
                </div>
              ))}
            </Card>
          )
        }
  const inputBoxStyle = {
    backgroundColor:"rgb(235, 235, 235)",
    padding: "6px 10px",
    borderRadius: "4px",
    display: "block",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    flexGrow: 1,
    minWidth: 0,
  }
  const inputRightBoxStyle = {
    textAlign: "right",
    backgroundColor:"rgb(235, 235, 235)",
    padding: "6px 10px",
    borderRadius: "4px",
    display: "block",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    flexGrow: 1,
    minWidth: 0,
  }
  const inputDateStyle = {
    outline: "0.015625rem thin #d3d3d3",
    borderradius: "5px", 
    border: "thin solid #d3d3d3",
    paddingLeft: "6px",
    borderRadius: "4px",
    backgroundColor:"rgb(235, 235, 235)",
    width: "100%",
  }
  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    return `${year}-${month}-${day}`
  }

     const getProcessNameControl = () => (
        <React.Fragment>
          <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
            <label className="form-label">Process Name</label>
            <InputText
              type="text"
              id="processName"
              name="processName"
              onChange={(e) => setProcessName(e.target.value)}
              placeholder="Enter process name"
              disabled={isLoading}
              className="input-outline"
            />
          </div>
        </React.Fragment>
      );

      const getDescriptionControl = () => (
        <React.Fragment>
          <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
            <label className="form-label">Process Description</label>
            <InputText
              type="text"
              id="description"
              name="description"
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter description"
              disabled={isLoading}
              className="input-outline"
            />
          </div>
        </React.Fragment>
      );

      const getStartEndDateControls = () => (
          <React.Fragment>
            <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
              <label className="form-label">Start Date Active</label>
              <div className="input-group date input-wrapper">
              <input
                type="date"
                id="StartDate"
                name="StartDate"
                value={startDate}
                onChange={handleStartDateChange}
                disabled={isLoading}
                className="input-outline1"
              />
              </div>
            </div>
            <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
              <label className="form-label">End Date Active</label>
              <div className="input-group date input-wrapper">
              <input
                type="date"
                id="EndDate"
                name="EndDate"
                value={endDate}
                onChange={handleEndDateChange}
                disabled={isLoading}
                className="input-outline1"
              />
              </div>
            </div>
          </React.Fragment>
        );
      
        const handleStartDateChange = (e) => {
          setStartDate(e.target.value);
        };
      
        const handleEndDateChange = (e) => {
          setEndDate(e.target.value);
        };

     const getGoButtonControl = () => (
        <React.Fragment>
          <div className="col-auto d-flex align-items-center justify-content-center ps-2 pe-0" style={{paddingTop:'31px'}}>
            <button
              type="button"
              className="btn btn-primary load-button"
              id={"chartAreaId"}
              onClick={handleLoadData}
              disabled={isLoading}
            >
               <i
                className={
                  isLoading ? "fa-duotone fa-fw fa-rotate fa-spin" : "fa-duotone fa-fw fa-rotate"
                }
              ></i>
              <span>{isLoading ? "Loading" : "Go"}</span>
            </button>
          </div>
        </React.Fragment>
      );
  return (
    <div>
      <Toast ref={toast} />
    <div className="col mx-2">
        {getLoadedHeaderContents()}
        <div className="row">
          <div className="col">
            <div className="row justify-content-center">
              {getProcessNameControl()}
              {getDescriptionControl()}
              {getStartEndDateControls()}
              {getGoButtonControl()}
            </div>
            {!wasDataFetchingSuccessful && (
              <div className="card my-3">
            {/* <div className="text-3xl text-800 font-bold mb-4">Inquire Process Name</div> */}
            <DataTable
              ref={dt}
              value={rows}
              selection={selectedRows}
              onSelectionChange={(e) => setSelectedRows(e.value)}
              dataKey="process_id"
              scrollable
              scrollHeight="flex"
              className="custom-datatable-border"
              tableStyle={{ minWidth: "50rem" }}
              paginator
              rows={pecaPageRows}
              rowsPerPageOptions={pecaRowsPerPageOptions}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} process"
              globalFilter={globalFilter}
              header={header}
              emptyMessage="No process found"
              stripedRows
              showGridlines        
              responsiveLayout="scroll"
              rowExpansion
            >
              {/* <Column
                body={drillDownTemplate}
                style={{ width: "0.75rem", textAlign: "center" }}
              /> */}
              <Column
                body={readBodyTemplate}
                exportable={false}
                style={{ width: "0.75rem" }}
              ></Column>
              <Column
                field="process_id"
                header="id"
                sortable="false"
                hidden="true"
                exportable={false}
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="process_name"
                header="Process Name"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="process_description"
                header="Process Description"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="process_start_lot_seq_number"
                header="Process Start Lot Seq Number"
                body={lotTemplate}
                sortable
                style={{ whiteSpace: "nowrap", textAlign: "right" }}
              ></Column>
              <Column
                field="admin_form_heading"
                header="Admin Form Heading"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="process_start_date_active"
                header="Process Start Date Active"
                body={startDateBodyTemplate}
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="process_end_date_active"
                header="Process End Date Active"
                body={endDateBodyTemplate}
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                body={actionBodyEditTemplate}
                style={{ width: "0.75rem" }}
              ></Column>
              <Column
                body={actionBodyDeleteTemplate}
                style={{ width: "0.75rem" }}
              ></Column>
            </DataTable>
          </div>
        )}
        </div>
        </div>

        <Dialog
          visible={rowDialog}
          style={{ width: "1400px" }}
          modal
          className="p-fluid"
          onHide={hideDialog}
        >
          <h4 style={{"fontWeight":"bold"}}> Inquire Process Name </h4>
          <Divider className="my-4" />
          <h5 style={{"fontWeight":"bold"}}>  {dialog === "edit" ? "Update Process Name Information" : dialog === "create" ? "Create New Process Name Information" : ""} </h5>
          <Divider className="my-4" />
          <div className="card-wrapper">
          <Card className="card-containers">
            <h5  style={{"fontWeight":"bold"}}> Process Details </h5>
            <Divider className="my-2" />
            <div className="label-value-pair">
            <span className="label" htmlFor="process_name">Process Name : </span>
            <span style={{flexGrow:1}}>
            <InputText
              id="process_name"
              value={row.process_name}
              onChange={(e) => onInputChange(e, "process_name")}
              required
              autoFocus
              className={classNames({
                "p-invalid": submitted && !row.process_name,
              })}
              style={inputBoxStyle}
            />
            </span>
            {submitted && !row.process_name && dialog === "create" && (
              <small className="p-error">Process Name is required.</small>
            )}
          </div>
          <div className="label-value-pair">
            <span className="label"htmlFor="process_description">Process Description : </span>
            <span style={{flexGrow:1}}>
            <InputText
              id="process_description"
              value={row.process_description}
              onChange={(e) => onInputChange(e, "process_description")}
              style={inputBoxStyle}
            />
            </span>
          </div>
          <div className="label-value-pair">
            <span className="label" htmlFor="process_start_lot_seq_number">Process Start Lot Seq Number : </span>
              <span style={{flexGrow:1}}>
                <InputNumber
                  id="process_start_lot_seq_number"
                  value={lotNumber}
                  onValueChange={(e) => onInputChange(e, "process_start_lot_seq_number")}
                  inputStyle={inputRightBoxStyle}
                />
              </span>
          </div>
          <div className="label-value-pair">
            <span className="label" htmlFor="admin_form_heading">Admin Form Heading : </span>
            <span style={{flexGrow:1}}>
            <InputText
              id="admin_form_heading"
              value={row.admin_form_heading}
              onChange={(e) => onInputChange(e, "admin_form_heading")}
              style={inputBoxStyle}
            />
            </span>
          </div>
          </Card>
          <Card className="card-containers">
            <h5  style={{"fontWeight":"bold"}}> Active Dates </h5>
            <Divider className="my-2" />
            <div className="label-value-pair">
            <span className="label" htmlFor="process_start_date_active">Process Start Date Active : </span>
            <span style={{flexGrow:1}} className="input-wrapper">
            <input
              type="date"
              id="process_start_date_active"
              defaultValue={formatDateTime(row.process_start_date_active)}
              onChange={(e) => onInputChange(e, "process_start_date_active")}
              style={inputDateStyle}
            />
            </span>
          </div>
          <div className="label-value-pair">
            <span className="label" htmlFor="process_end_date_active">Process End Date Active : </span>
            <span style={{flexGrow:1}} className="input-wrapper">
            <input
              type="date"
              id="process_end_date_active"
              defaultValue={formatDateTime(row.process_end_date_active)}
              onChange={(e) => onInputChange(e, "process_end_date_active")}
              style={inputDateStyle}
            />
            </span>
          </div>
          </Card>
          </div>
          <div className="btn-container">
          <Button
            label="Cancel"
            icon="pi pi-times"
            className="p-button-text"
            onClick={hideDialog}
            style={{"width":"20%","backgroundColor":"#0d6efd", "color":"white", "borderRadius":"4px", "cursor":"pointer"}}
          />
          <Button
            label="Save"
            icon="pi pi-check"
            className="p-button-text"
            onClick={saveRow}
            style={{"width":"20%","backgroundColor":"#0d6efd", "color":"white", "borderRadius":"4px", "cursor":"pointer"}}
          />
          </div>
        </Dialog>

        <Dialog
          visible={deleteRowDialog}
          style={{ width: "450px" }}
          header="Confirm"
          modal
          footer={deleteRowDialogFooter}
          onHide={hideDeleteRowDialog}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle p-mr-3"
              style={{ fontSize: "1.5rem", paddingRight: "10px" }}
            />
            {row && (
              <span>
                Are you sure you want to delete <b>{row.process_name}</b>?
              </span>
            )}
          </div>
        </Dialog>

       <Dialog visible={showproductDialog} style={{ width: '1400px' }} modal className="p-fluid" onHide={hideDialog}>     
                        <h4 style={{"fontWeight":"bold"}}> Inquire Process Name </h4>
                        <Divider className="my-4" />
                        <h5 style={{"fontWeight":"bold"}}> View Process Name Information </h5>
                        <Divider className="my-4" />
                        <div className="card-wrapper">
                          <CardComponent
                            title="Process Details"
                            data={[
                              {label:"Process Name : ", value: row.process_name },
                              {label:"Process Description : ", value: row.process_description },
                              {label:"Process Start Lot Seq Number : ", value: lotNumber },
                              {label:"Admin Form Heading : ", value: row.admin_form_heading },
                            ]}
                          />
                          <CardComponent
                            title="Active Dates"
                            data={[
                              {label:"Process Start Date Active : ", value: sDate },
                              {label:"Process End Date Active : ", value: eDate },
                            ]}
                          />
                         </div>
                    </Dialog>
                    <Dialog 
                        header="API Error" 
                        visible={errorDialogVisible} 
                        style={{ width: '400px' }} 
                        onHide={hideDialog} 
                        footer={
                            <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                        }
                    >    
                     <p>
        
                            {errorMessage}
                        </p>
                    </Dialog>
                    <style jsx>{`
                      .card-wrapper {
                        display: grid;
                        grid-template-columns: repeat(2,1fr);
                        gap: 10px;
                        padding: 5px;
                      }
        
                      .card-containers {
                        display: flex;
                        background-color: #f9f9f9;
                        flex-direction: column;
                        justify-content: flex-start;
                        border: 1px solid #ccc;
                        paddig: 10px;
                        box-shadow: 4px 4px 10px rgba(0,0,0,0.2);
                        height: auto;
                        width: 100%;
                      }
        
                      .label-value-pair {
                        display: flex;
                        flex-direction: row,
                        align-items: flex-start;
                        gap: 5px;
                        margin-bottom: 8px;
                        flex-wrap: wrap;
                      }
        
                      .label {
                        font-weight: bold;
                        white-space: nowrap;
                      }
        
                      .value-box {
                        background-color:rgb(235, 235, 235);
                        padding: 6px 10px;
                        border-radius: 4px;
                        display: block;
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        flex-grow: 1;
                        min-width: 0;
                      }

                      .align-right {
                        text-align: right;
                        background-color:rgb(235, 235, 235);
                        padding: 6px 10px;
                        border-radius: 4px;
                        display: block;
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        flex-grow: 1;
                        min-width: 0;
                      }

                      .btn-container {
                      display: flex;
                      justify-content: center;
                      gap:20px;
                      margin-top:20px;
                      }
                    `}
                    </style>
                    </div>
    </div>
  );
};

export default ProcessNamesPG;
